import { render, staticRenderFns } from "./Proper.vue?vue&type=template&id=152856d6&"
import script from "./Proper.vue?vue&type=script&lang=js&"
export * from "./Proper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports